var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlackInstaShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Slider"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.50578 1.90017L17.6315 1.89941C17.9034 1.8994 18.1544 2.04535 18.2888 2.28169C18.4233 2.51802 18.4206 2.80834 18.2816 3.04209L10.4904 16.1515C10.3333 16.4159 10.0318 16.5588 9.72767 16.513C9.42358 16.4672 9.17749 16.2419 9.10519 15.943L7.2805 8.40069L1.97616 3.19629C1.75688 2.98115 1.68953 2.65475 1.80573 2.37038C1.92193 2.08601 2.19859 1.90019 2.50578 1.90017ZM8.83525 8.39468L10.1387 13.7826L15.5535 4.67184L8.83525 8.39468ZM14.7061 3.41213L4.3564 3.41265L8.09161 7.07748L14.7061 3.41213Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackInstaShare);
export default __webpack_public_path__ + "static/media/black-insta-share.a2738f3fda45c0a0ef5961888c31bc7a.svg";
export { ForwardRef as ReactComponent };